import apiZelo from '../backAxiosVendaToken';
import api from '../backAxios';
import { retornoHashValor } from '../../modulos/cripotografia/hash';

const url = retornoHashValor(process.env.REACT_APP_1);
const token = localStorage.getItem('token');
let retorno;

export const buscaHieraquia = async (path,value) => {
    try {
        const response = await apiZelo.post(`/hierarquia${path}`, value);
 
        return response.data;
    } catch (error) {
        return error.message;
    }
};

export const BuscarAreaAtuacaoGerente = async cod => {
    await fetch(`${url}/area-de-atuacao/gerente/${cod}`, {
        method: 'get',
        headers: {
            'Content-Type': 'application/json',
            'x-auth-token': token
        }
    })
        .then(response => response.json())
        .then(responseJson => {
            retorno = responseJson;
            retorno.status = 200;
        })
        .catch(err => {
            retorno = err.message;
        });

    return retorno;
};

export const buscarSupervisorPorCPF = async (codigo, cpf) => {
    try {
        const supervisor = await api.get(`/access-vendedor/${codigo}/${cpf.replace(/\D/g,'')}`);

        return supervisor.data;
    } catch (error) {
        return error;
    }
};
